import { put, takeEvery } from 'redux-saga/effects';
import appAction from '../actions/app';
import { resetPatientWizardReturnType } from '../actions/patientWizardReset';
import * as types from '../constants/actionConstants';
import { resetPatientWizardStorage } from '../../tools/patientWizardStorage';

// Applies patient wizard reset to storage and Redux app slice.
function* sagaResetPatientWizard(action: resetPatientWizardReturnType): any {
  yield put(appAction.getAppData(resetPatientWizardStorage({ isIntegration: action.isIntegration })));
}

// Watches patient wizard reset actions.
export function* watchPatientWizard(): any {
  yield takeEvery(types.RESET_PATIENT_WIZARD, sagaResetPatientWizard);
}
